import { render, staticRenderFns } from "./Termometria.vue?vue&type=template&id=24fc5e9c&"
import script from "./Termometria.vue?vue&type=script&lang=js&"
export * from "./Termometria.vue?vue&type=script&lang=js&"
import style0 from "./Termometria.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Termometria.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports